var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStandardPlanLrg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1493",
    "data-name": "Group 1493",
    transform: "translate(0.488)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    rx: 3,
    transform: "translate(-0.488)",
    fill: "#659ba5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.521,15.219v-.825h-5.7l-.008,3.3a1.634,1.634,0,0,0,1.63,1.649H16.857a1.634,1.634,0,0,0,1.63-1.649v-3.3H12.782v.825ZM17.672,7.8H14.4V6.149L12.773,4.5H9.513L7.883,6.149V7.8H4.63A1.645,1.645,0,0,0,3,9.447v2.474A1.634,1.634,0,0,0,4.63,13.57H9.521V11.921h3.261V13.57h4.891a1.645,1.645,0,0,0,1.63-1.649V9.447A1.645,1.645,0,0,0,17.672,7.8Zm-4.891,0H9.521V6.149h3.261Z",
    transform: "translate(3.861 3.58)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandardPlanLrg);
export default __webpack_public_path__ + "static/media/standard_plan_lrg.0eac5af5e016de9c3de25dd0645fa450.svg";
export { ForwardRef as ReactComponent };